import { Component } from '@angular/core';
import {
  filter,
  first,
  take
} from 'rxjs/operators';
import { LoadStatus } from '@spartacus/organization/administration/core';
import {
  BaseItem,
  ConfirmationMessageComponent,
  ConfirmationMessageData,
  ItemService,
  MessageService,
  ToggleStatusComponent, DisableInfoService
} from '@spartacus/organization/administration/components';
import { FeatureConfigService } from '@spartacus/core';
import { UigB2BUser } from 'src/app/organization/uig-user/uig-user.model';
import { UigUserItemService } from 'src/app/organization/services/uig-user-item/uig-user-item.service';
@Component({
    selector: 'app-uig-user-toggle-status',
    templateUrl: './uig-user-toggle-status.component.html',
    styleUrls: ['./uig-user-toggle-status.component.scss'],
    providers: [
        {
            provide: ItemService,
            useExisting: UigUserItemService,
        }
    ],
    standalone: false
})
export class UigUserToggleStatusComponent extends ToggleStatusComponent<BaseItem> {
  constructor(protected itemService: ItemService<BaseItem>,
              protected messageService: MessageService<ConfirmationMessageData>,
              protected featureConfigService: FeatureConfigService,
              private uigUserItemService: UigUserItemService, disableInfoService: DisableInfoService<any>
  ) {
    super(itemService, messageService , disableInfoService);
  }

  toggle(item: UigB2BUser) {
    if (!item.active) {
      this.update(item);
    } else {
      if (!this.confirmation) {
        this.confirmation = this.messageService.add({
          message: {
            key: `${this.i18nRoot}${
              this.featureConfigService?.isLevel('3.2')
                ? '.messages.deactivateBody'
                : '.messages.deactivate'
            }`,
            params: { item },
          },
          messageTitle: {
            key: this.i18nRoot + '.messages.deactivateTitle',
            params: { item },
          },
          confirm: {
            key: 'organization.confirmation.disable',
          },
          component: ConfirmationMessageComponent,
        });

        this.subscription.add(
          this.confirmation.pipe(first()).subscribe((event) => {
            if (event.close) {
              this.confirmation = null;
            }
            if (event.confirm) {
              this.messageService.close(this.confirmation);
              this.update(item);
              this.confirmation = null;
            }
          })
        );
      }
    }
  }

  protected update(item:UigB2BUser): void {
    this.uigUserItemService
      .update(item[this.key], this.getPatchedItem(item))
      .pipe(
        take(1),
        filter((data) => data.status === LoadStatus.SUCCESS)
      )
      .subscribe(() => {
      });
  }

  protected getPatchedItem(item: UigB2BUser): UigB2BUser {
    const patch: UigB2BUser = {};
    patch[this.key] = item[this.key];
    patch.active = !item.active;
    patch.edit = true;
    return patch as UigB2BUser;
  }

  ngOnDestroy() {
    this.messageService.clear();
    this.confirmation = null;
    this.subscription?.unsubscribe();
  }

}
